import script from "./CalendarioVista.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioVista.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioVista.vue?vue&type=style&index=0&id=52fd55ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52fd55ee"]])

export default __exports__